import React from 'react';
import { Route } from "react-router-dom";
import PaymentsListing from './payments.list';
import PaymentRequestView from './payments.view';
import store from './filterStore';


const PaymentRequestsRouter = ({ match }) => (
  <div>
    <Route path={`${match.path}/:id`} component={PaymentRequestView} />
    <Route
      exact
      path={match.path}
      render={() => <PaymentsListing store={store} />}
    />
  </div>
);

export default PaymentRequestsRouter;
